import * as labels from "config.labels";

export const DEFAULT_TRANSACTION_OPTIONS = [
  {
    key: "NEW",
    name: "New Business",
    label: labels.PROGRAM_TRANSACTION_NEW_BUSINESS,
  },
  {
    key: "RENEWAL",
    name: "Renewal",
    label: labels.PROGRAM_TRANSACTION_RENEWAL,
  },
  { key: "MTA", name: "MTA", label: labels.PROGRAM_TRANSACTION_MTA },
  {
    key: "CANCELLATION",
    name: "Cancellation",
    label: labels.PROGRAM_TRANSACTION_CANCELLATION,
  },
  {
    key: "OPTION",
    name: "Alternative Option",
    label: labels.PROGRAM_TRANSACTION_ALT_OPTION,
  },
];

// Every transaction type with a built-in name, including those only offered
// when configured, so a nameless config entry or saved value still reads
// well. Mirrors TRANSACTION_DISPLAY_NAMES in submissions_list_support.py.
const KNOWN_TRANSACTION_TYPES = [
  ...DEFAULT_TRANSACTION_OPTIONS,
  {
    key: "REWRITE",
    name: "Rewrite",
    label: labels.PROGRAM_TRANSACTION_REWRITE,
  },
];

const byKey = (entries) =>
  Object.fromEntries(
    (entries ?? []).filter((e) => e?.key).map((e) => [e.key, e])
  );

const defaultsByKey = byKey(KNOWN_TRANSACTION_TYPES);

/**
 * Options for the Transaction dropdown from the `transaction_types` config
 * (`{ all, active }`, as `business_units`). `active` is offered; a configured
 * name is used verbatim so it carries no translation label. `selected` is
 * appended when `active` no longer contains it, named from `all`.
 */
export const makeTransactionOptions = (config, selected) => {
  const all = byKey(config?.all);
  const resolveName = ({ key, name }) =>
    name ?? all[key]?.name ?? defaultsByKey[key]?.name ?? key;

  const active = (config?.active ?? [])
    .filter((e) => e?.key)
    .map((e) => ({ key: e.key, name: resolveName(e) }));
  const options = active.length ? active : DEFAULT_TRANSACTION_OPTIONS;

  if (!selected || options.some(({ key }) => key === selected)) {
    return options;
  }

  const saved = all[selected]
    ? { key: selected, name: resolveName(all[selected]) }
    : defaultsByKey[selected] ?? { key: selected, name: selected };
  return [...options, saved];
};
